/** 首页 · 租赁业务概况 mock 数据（与 UI 稿字段一致） */
export const DASHBOARD_HOME_TABS = [
  { key: 'lease', label: '租赁业务概况', perm: 'op_hd_lease_view' },
  { key: 'performance', label: '业绩概况', perm: 'op_hd_perf_view' },
  { key: 'dealer', label: '经销商概况', perm: 'op_hd_dealer_view' },
  { key: 'afterSales', label: '售后概况', perm: 'op_hd_after_view' },
  { key: 'user', label: '用户概况', perm: 'op_hd_user_view' },
  { key: 'core', label: '核心业绩概况', perm: 'op_hd_core_view' },
]

export const leaseDashboardData = {
  monthRenewal: {
    pendingDevices: { value: 50000, unit: '台', rate: 80.12 },
    expectedAmount: { value: 2000000, unit: '元', rate: 80.12 },
    rows: [
      {
        type: 'time',
        label: '时间型',
        pendingDevices: 10000,
        pendingAmount: 900000000,
        renewedDevices: 10000,
        renewedAmount: 900000000,
        deviceRate: 80.12,
        amountRate: 80.12,
      },
      {
        type: 'service',
        label: '服务包',
        pendingDevices: 50000,
        pendingAmount: 900000000,
        renewedDevices: 50000,
        renewedAmount: 900000000,
        deviceRate: 80.12,
        amountRate: 80.12,
      },
    ],
  },
  monthNewInstall: {
    devices: { value: 50000, unit: '台', rate: 80.12, mom: 80.12, momUp: true, yoy: -10.12, yoyUp: false },
    amount: { value: 2000000, unit: '元', rate: 80.12, mom: 80.12, momUp: true, yoy: -10.12, yoyUp: false },
    rows: [
      { type: 'time', label: '时间型', devices: 10000, amount: 900000000, deviceRate: 80.12, amountRate: 80.12 },
      { type: 'traffic', label: '流量型', devices: 10000, amount: 900000000, deviceRate: 80.12, amountRate: 80.12 },
    ],
  },
  leasingDevices: {
    total: 150000,
    time: { count: 70000, ratio: 40 },
    traffic: { count: 70000, ratio: 60 },
  },
  abnormalDevices: {
    items: [
      { key: 'waterQuality', label: '水质异常', count: 10000 },
      { key: 'offline', label: '离线超30天', count: 10000 },
      { key: 'fault', label: '故障码超24小时', count: 10000 },
    ],
  },
  yearNewDevices: {
    total: 150000,
    mom: 80.12,
    momUp: true,
    types: [
      { label: '时间型', count: 10000, ratio: 80.12 },
      { label: '流量型', count: 10000, ratio: 80.12 },
    ],
    byProduct: [
      { label: '白略豚PLUS', count: 10000 },
      { label: '大白鲨', count: 10000 },
      { label: '白鳍豚', count: 10000 },
      { label: '小黑鲨', count: 10000 },
    ],
    bySource: [
      { label: '经销商渠道', count: 10000 },
      { label: '直营渠道', count: 10000 },
      { label: '电商渠道', count: 10000 },
    ],
    byUser: [
      { label: '学校', count: 10000 },
      { label: '医院', count: 10000 },
      { label: '政府部门', count: 10000 },
      { label: '国央企', count: 10000 },
    ],
  },
  yearRevenue: {
    total: {
      amount: 2000000,
      mom: 80.12,
      momUp: true,
      types: [
        { label: '时间型', amount: 1900000000, ratio: 80.12 },
        { label: '流量型', amount: 1900000000, ratio: 80.12 },
      ],
    },
    timeComposition: {
      amount: 2000000,
      mom: 80.12,
      momUp: true,
      items: [
        { label: '新装收入', amount: 50000000, ratio: 80.12 },
        { label: '续租/续费', amount: 50000000, ratio: 80.12 },
      ],
    },
    trafficComposition: {
      amount: 2000000,
      mom: 80.12,
      momUp: true,
      items: [
        { label: '新装收入', amount: 50000000, ratio: 80.12 },
        { label: '续租/续费', amount: 50000000, ratio: 80.12 },
      ],
    },
  },
}

export function formatDashboardNum(n, decimals = 0) {
  if (n == null || Number.isNaN(Number(n))) return '—'
  return Number(n).toLocaleString('zh-CN', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}

export function formatDashboardAmount(n) {
  if (n == null || Number.isNaN(Number(n))) return '—'
  const v = Number(n)
  if (v >= 100000000) return formatDashboardNum(v, 0)
  return formatDashboardNum(v, 2)
}
